import React from "react";

export const AppContext = React.createContext({
    currentUser: null,
    sendUserToDb: (user, credential) => {},
    logout: () => {},
    selectCurrentEvent: (event) => {},
    audioActive: false,
    toggleAudioActive: () => {}
})